import React from 'react';

const contexts = {};

export const createContext = name => {
  contexts[name] = React.createContext();
  return contexts[name];
};

export const useDrawer = name => React.useContext(contexts[name]);

export default contexts;
